angular.module('eatself').component('expandableDescription', {
	bindings: {
		description: '<',
		isClosed: '=',
	},
	controllerAs: 'vm',
	controller: angular.module('eatself').classy.controller({
		inject: ['DISPLAY_LENGTH','$element','$scope'],
		methods: {
			$onInit() {
				this.isClosed = true;
				this.trunclength = 200;
			},
			expanding() {
				this.trunclength = this.description.length;
			},
			collapsed() {
				this.$element.find('.colipse').css('height','85px');
				this.$element.find('.colipse').css('display','block');
				this.$element.find('.colipse').css('overflow','hidden');
				this.trunclength = 200;
			}
		}
	}),
	template: `
	<style>
		.colipse {
			min-height: 85px;
		}
	</style>
	<div>
		<span>
			<div class="colipse" uib-collapse="vm.isClosed" collapsed="vm.collapsed()" expanding="vm.expanding()" ng-bind-html="vm.description|truncate:vm.trunclength"></div>
			<a href ng-if="vm.description.length > 200" ng-click="vm.isClosed = !vm.isClosed">
				<span ng-if="vm.isClosed">suite...</span>
				<span ng-if="!vm.isClosed">réduire</span>
			</a>
		</span>
	</div>
	`
})